import Vue from "vue";
// import "vant/lib/index.css";
import App from "./App.vue";
import router from "./router/index";
// import "@/assets/style/font/iconfont.css";
import "@/assets/style/index.less";
import $axios from "@/utils/request";
import mixin from "./mixin/index";
import store from "./store/index";
import {Search,Picker, Divider,Toast,ActionSheet,Empty ,Uploader,DropdownMenu, DropdownItem,Tabbar, TabbarItem,Tab, Tabs ,Swipe, SwipeItem,Sticky} from 'vant';

import "@/components/Vant";
import {getavatar }from './utils/fillter'
// rem
import "amfe-flexible";
import Vconsole from 'vconsole';
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

// new Vconsole()
// import VideoPlayer from 'vue-video-player'
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')

// Vue.use(VideoPlayer)
// 把变量挂载到vue的原型上
Vue.filter('getavatar', getavatar)  
Vue.prototype.$axios = $axios;
Vue.prototype.Toast=Toast
Vue.mixin(mixin);

Vue.config.productionTip = false;

// Vue.use(Toast)
Vue.use(ActionSheet)
Vue.use(Empty)
Vue.use(Uploader)
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Divider);
Vue.use(Picker);
Vue.use(Search);
Vue.use(Sticky);


Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
